import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  prompt: z.string().min(1).max(2000),
  lyrics: z.string().max(5000).optional(),
  seed: z.number().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  audioUrl: string;
  duration?: number;
};

export async function generateMusic(input: InputType): Promise<OutputType> {
  const response = await fetch('/_api/music-video/generate-music', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: superjson.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const text = await response.text();
    let errMsg = 'Failed to generate music';
    try { errMsg = superjson.parse<{ error: string }>(text).error || errMsg; } catch {
      try { errMsg = JSON.parse(text).error || errMsg; } catch { errMsg = text || errMsg; }
    }
    throw new Error(errMsg);
  }

  const text = await response.text();
  try { return superjson.parse<OutputType>(text); } catch {
    return JSON.parse(text) as OutputType;
  }
}
